<script lang="ts" module>
  export interface NavbarHeaderTopProps {
    navData?: NavData;
  }
</script>

<script lang="ts">
  import { page } from "$app/state";

  import { NavbarRow, NavbarMenuBar, NavbarItem } from "@agapi/ui/navbar";

  import type { NavData } from "../../../types/navData";
  import LanguagePicker from "../../language-picker/language-picker.svelte";
  import { rewriteUrl, getIsMultiMarket } from "../../../utils";

  import { locales } from '$lib/parachute/runtime'

  const isMultiMarket = getIsMultiMarket()
  const { navData }: NavbarHeaderTopProps = $props();
</script>

 <!-- Top Navbar -->
 <NavbarRow colorVariant="navbar.top" css={{ display: 'none', md: { display: 'flex' } }}>
  <NavbarMenuBar label="Support and content">
    {#each navData?.top_nav_items ?? [] as item}
      <NavbarItem label={item.label} href={rewriteUrl(page, item.path)} />
    {/each}

    {#if isMultiMarket && locales.length > 1}
      <LanguagePicker />
    {/if}
  </NavbarMenuBar>
</NavbarRow>
